import React from 'react';
import { Field, ErrorMessage } from 'formik';
import { Typography, Button } from '@material-tailwind/react';
import { seleccionarTextoInput } from '../../Helpers/utilidades-globales';

export const TabPersonalMinisterial = ({
    id_obrero, dirty, resetForm, initialValues, values, handleChange, sexoOptions,
    estadosCiviles, nacionalidades, regiones, rangos, tiposDocumentos, en_tramite
}) => {
    return (
        <div className="AnaliticoContainer bg-white p-5 rounded-md mb-4 lg:space-x-10 relative">
            <div className="">
                <div className="flex f-col">
                    {id_obrero && dirty &&
                        <Button type="button"
                            className="cursor-pointer w-32 mb-2"
                            onClick={() => resetForm(initialValues)}>
                            Restaurar
                        </Button>
                    }
                    <div className="flex f-col">
                        <div className="flex flex-col">
                            <Typography
                                variant="small"
                                color="blue-gray"
                                className="mb-1 font-medium "
                            >
                                Nombre (apellido nombre)
                            </Typography>
                            <Field
                                id="abm-nombre"
                                type="text"
                                autoComplete="off"
                                maxLength="100"
                                name="nombre"
                                onFocus={() => seleccionarTextoInput("abm-nombre")}
                                onClick={() => seleccionarTextoInput("abm-nombre")}
                                className={`input-ui-data ${values.nombre ? 'input-cvalor' : 'input-vacio'}`}
                            />
                        </div>
                        <div className="error_formulario"><ErrorMessage name="nombre" /></div>
                    </div>
                    {/* Rest of Personal & Ministerial Content will be moved here from Abm-obrero.js */}
                </div>
            </div>
        </div>
    );
};